export class InsurerAddressModel {

  postalCode: string;

  constructor() {
    this.postalCode = '';
  }
}
